import axios, { UMS_ENDPOINT } from '../../../utils/httpClient'

export const ORG = localStorage.getItem('e_trans_org')

export const reset = (data) => {
    return axios.post(`${UMS_ENDPOINT}/${ORG}/password/reset`, data)
}

// samboabubakar5+15273@gmail.com
